import { DatarouterError } from '@zg-rentals/web-base';
import type { ErrorInterface } from '@common/types';

type PaymentErrorInfo = {
  httpStatus: number | undefined;
  errorCode: string | undefined;
};

/**
 * Extracts HTTP status and error code from either a DatarouterError (ts-client)
 * or an ErrorInterface (legacy RSAA action). This allows catch blocks to handle
 * both error types with a single, consistent API.
 */
export function getPaymentErrorInfo(error: unknown): PaymentErrorInfo {
  if (DatarouterError.is(error)) {
    return {
      httpStatus: error.responseStatus,
      errorCode: error.code,
    };
  }

  // Fallback for legacy RSAA action errors (ErrorInterface)
  const rsaaError = error as ErrorInterface;
  if (rsaaError?.action?.payload) {
    return {
      httpStatus: rsaaError.action.payload.status,
      errorCode: rsaaError.action.payload.response?.messageCode,
    };
  }

  return { httpStatus: undefined, errorCode: undefined };
}
